var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 0H7.8A8 8 0 0 0 0 8v47a8 8 0 0 0 7.8 8h45.7a8 8 0 0 0 7.9-8V8c0-4.4-3.5-8-7.9-8Z",
    fill: "#8CDBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.8 58.3-6.7-4.5L9.6 48l-7-5.2L9 35.7.4 30l8.1-7 3.3 35.3Z",
    fill: "#0D1013"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6 22.5c-1.4-1-3.4-.7-5.1.6.4-2.7-.8-5-2.8-5.6-2-.5-4.3 1-5.4 3.4-4.4-.8-10.1-.6-16.9-.2l-20.1 1v.2s2.3 22.7 3.4 41.1h33.4c0-5 .4-13 .4-13 3.1 0 9-.7 9.2-.9 0 0 1.2-7.1.4-17.6a6.8 6.8 0 0 0 3.3-2.4c1.8-2.5 2-5.3.2-6.6Z",
    fill: "#FF6170"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4 45.9.9 17.1h20.8l.4-12c-7.7 0-15.8-1-22.1-5.1Z",
    fill: "#FFC400"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4 19.9c.8.4 1 1.8.5 3.1-.5 1.4-1.6 2.1-2.4 1.7-.8-.4-1-1.8-.6-3.1.5-1.3 1.7-2 2.5-1.7ZM57.2 24.8c.7.6.5 2-.4 3-1 1-2.4 1.4-3 .8-.8-.6-.6-2 .4-3s2.3-1.4 3-.8ZM12 3.3c1.4-.2 2.5.2 2.8 1 .3 1-.7 2-1.6 2.3a19 19 0 0 0-3.3 3c-.6.4-1.7.4-2.2 0-.5-.6-.5-1.6-.2-2.3.7-1.8 2.4-3.7 4.5-4ZM30.4 2.3c-1.5 0-2.5.5-2.7 1.4-.2 1 1 1.8 1.7 2 .9.2 3.1 2 3.7 2.5.7.5 1.7.4 2.2-.2.5-.5.3-1.6-.1-2.2-1-1.7-2.7-3.4-4.8-3.5Z",
    fill: "#0D1013"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 9.2c4.8 0 8.7 3.9 8.7 8.9s-4 8.8-8.7 8.8c-4.7 0-8.6-3.9-8.6-8.8 0-5 3.9-9 8.6-9Z",
    fill: "#6F578E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 8.5c4.7 0 8.6 4 8.6 8.8 0 4.9-3.9 9-8.6 9-4.7 0-8.6-4.1-8.6-9 0-5 3.9-8.8 8.6-8.8Z",
    fill: "#6F578E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 12.4c3.1 0 5.6 2.5 5.6 5.7 0 3.1-2.5 5.7-5.6 5.7A5.6 5.6 0 0 1 10 18c0-3.2 2.4-5.7 5.5-5.7Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 15.4c1.5 0 2.6 1.2 2.6 2.7 0 1.5-1.1 2.6-2.6 2.6a2.6 2.6 0 0 1-2.5-2.6c0-1.5 1.1-2.7 2.5-2.7Z",
    fill: "#0D1013"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 11.6c3.1 0 5.6 2.6 5.6 5.7a5.6 5.6 0 1 1-11.1 0c0-3.1 2.4-5.7 5.5-5.7Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 14.6c1.4 0 2.6 1.1 2.6 2.6S29.8 20 28.4 20a2.6 2.6 0 0 1-2.6-2.7c0-1.5 1.2-2.6 2.6-2.6Z",
    fill: "#0D1013"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 50c-3.6 0-12.2-.8-17.4-2.6-4.1-1.4-9.4-4-10.5-8.6-.1-.5-.6-.6-.8-.6-.5.1-.7.6-.6.9 2.3 9.2 19.9 12.6 29.3 12.3V50Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m17.9 42.3-.3 6.7 6.6-1.7 2.3 6 6-3.2 3.4 5.3 4.8-4.4-1.7-.6-8.6-1.6-6.8-2.3-5.7-4.2Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon_1.69eb80286f2c5a2047976abd024b84f7.svg";
export { ForwardRef as ReactComponent };